import { NgModule } from '@angular/core';
import { ChipComponent } from '@seech/shared-ng';
import {
  AlertComponent,
  PlaceholderComponent,
  SpinnerComponent,
  TabsComponent,
  TabComponent,
  ProgressBarComponent,
  AccordionComponent,
  AccordionItemComponent,
  ChipsComponent,
  StepperComponent,
  StepComponent,
  BadgeComponent,
  ConfirmationDialogComponent,
  TreeViewComponent,
  HttpProgressIndicatorComponent,
  AvatarComponent,
} from './components';
import {
  DialogModule,
  ModalModule,
  NotificationModule,
  TooltipModule,
} from './modules';
import { CommonModule } from '@angular/common';
import {
  BadgeDirective,
  MenuDirective,
  MenuItemDirective,
  MenuTriggerDirective,
  ScrollEndNotifierDirective,
} from './directives';
import { ToastComponent } from './components/toast/toast.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpFeedbackInterceptor, HttpProgressInterceptor } from './interceptors';

export const COMPONENTS = [
  AlertComponent,
  PlaceholderComponent,
  SpinnerComponent,
  TabsComponent,
  TabComponent,
  AccordionComponent,
  AccordionItemComponent,
  ProgressBarComponent,
  HttpProgressIndicatorComponent,
  AvatarComponent,
  TabsComponent,
  DialogModule,
  ModalModule,
  NotificationModule,
  ChipComponent,
  ChipsComponent,
  CommonModule,
  TooltipModule,
  StepperComponent,
  StepComponent,
  BadgeComponent,
  BadgeDirective,
  ConfirmationDialogComponent,
  ScrollEndNotifierDirective,
  ToastComponent,
  TreeViewComponent,
  MenuTriggerDirective,
  MenuItemDirective,
  MenuDirective,
  OverlayModule,
];

@NgModule({
  imports: [
    ...COMPONENTS
  ],
  exports: [
    ...COMPONENTS
  ],
  declarations: [],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpProgressInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpFeedbackInterceptor,
      multi: true,
    },
  ],
})
export class UxNgModule { }
